import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getAdminSessionInfos,
  getAdminSessionInfoById,
  createAdminSessionInfo,
  updateAdminSessionInfo,
  deleteAdminSessionInfo,
} from "../../api/admin/sessionInfo.api";

/* ============================================================
   FETCH SESSION INFO LIST
============================================================ */

export const fetchSessionInfos = createAsyncThunk(
  "admin/sessionInfo/fetch",
  async (
    { page = 1, limit = 10, search = "" } = {},
    { rejectWithValue }
  ) => {
    try {
      const res = await getAdminSessionInfos({
        page,
        limit,
        search,
      });

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch Session Instances."
      );
    }
  }
);

/* ============================================================
   FETCH SINGLE SESSION INFO (DETAILED INSTANCE WITH ROSTER)
============================================================ */

export const fetchSessionInfoById = createAsyncThunk(
  "admin/sessionInfo/fetchById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await getAdminSessionInfoById(id);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch Session Instance details."
      );
    }
  }
);

/* ============================================================
   CREATE SESSION INFO (INITIALIZE INSTANCE + ATTENDANCE)
============================================================ */

export const addSessionInfo = createAsyncThunk(
  "admin/sessionInfo/add",
  async (payload, { rejectWithValue }) => {
    try {
      console.log(
        "📡 ADD SESSION INFO PAYLOAD:",
        payload
      );

      const res = await createAdminSessionInfo(payload);

      console.log(
        "📥 ADD SESSION INFO RESPONSE:",
        res
      );

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to create Session Instance."
      );
    }
  }
);

/* ============================================================
   UPDATE SESSION INFO (SYNCHRONIZE METADATA & ROSTER VARIATIONS)
============================================================ */

export const updateSessionInfo = createAsyncThunk(
  "admin/sessionInfo/update",
  async (
    {
      id,
      sessionInfoData,
    },
    { rejectWithValue }
  ) => {
    try {
      console.log(
        "📡 UPDATE SESSION INFO PAYLOAD:",
        { id, sessionInfoData }
      );

      const res = await updateAdminSessionInfo(
        id,
        sessionInfoData
      );

      console.log(
        "📥 UPDATE SESSION INFO RESPONSE:",
        res
      );

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to update Session Instance and Roster."
      );
    }
  }
);

/* ============================================================
   DELETE SESSION INFO (CASCADE REMOVE)
============================================================ */

export const deleteSessionInfo = createAsyncThunk(
  "admin/sessionInfo/delete",
  async (
    id,
    { rejectWithValue }
  ) => {
    try {
      const res = await deleteAdminSessionInfo(id);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return {
        id,
        message: res.message,
      };
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to delete Session Instance."
      );
    }
  }
);